<template>

	<div class="col">
		<div class="content">
			<div>
				<div class="cat-icon">
					<slot name="icon"></slot>
				</div>
				<p>
					<slot name="label"></slot>
				</p>
			</div>
			<slot name="status"></slot>
			<div class="bar"><slot name="inner-status"></slot></div>
		</div>
		<slot name="list"></slot>
		<slot name="extra"></slot>
	</div>

	
</template>
<script>
	
	import Vue from 'vue';
    import SvgIcon from './Svg.vue';
    export default {
    	components:{
			SvgIcon
		},
		data: () => ({
	
		})
	}

</script>